<template>
  <div>
    <List
      url="cloud/server/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
        <el-select multiple v-model="selectClouds" placeholder="选择云平台（多选）" style="width:200px;margin-right:10px;" size="small">
          <el-option
            v-for="cloud in cloudEnvList"
            :label="cloud"
            :key="cloud"
            :value="cloud"></el-option>
        </el-select>
        <el-input
          v-model="searchData.server_name"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入服务器名称"
        ></el-input>
        <el-input
          v-model="searchData.public_ip"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入公网IP"
        ></el-input>
        <el-input
          v-model="searchData.private_ip"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入内网IP"
        ></el-input>
        <el-button
          @click="search"
          type="primary"
          size="small"
          >Search</el-button>
        <el-button
          @click="add"
          type="primary"
          size="small"
          icon="el-icon-edit"
          >新增</el-button>
      </div>
    </List>
    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      :cloudEnvList="cloudEnvList"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/CloudServer/UpdateBox.vue";

export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      dialogFormVisible: false,
      title: "云平台服务器",
      tanle: [
        { name: "cloud", label: "云平台" },
        { name: "server_name", label: "服务器名称" },
        { name: "public_ip", label: "公网IP" },
        { name: "private_ip", label: "内网IP" },
        { name: "has_csmain", label: "是否有csmain" },
        { name: "has_csconfig", label: "是否有csconfig" },
        { name: "desc", label: "备注" },
        { name: "create_time", label: "创建时间" }
      ],
      selectClouds: [],
      searchData: {
        cloud: "",
        server_name: "",
        public_ip: "",
        private_ip: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      cloudEnvList: [],
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
        data[i].has_csmain = data[i].has_csmain ? "是" : "否";
        data[i].has_csconfig = data[i].has_csconfig ? "是" : "否";
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateType = "add";
      this.updateForm = { has_csmain: "是", has_csconfig: "否" };
      this.updateBlock = true;
    },
    search() {
      this.searchData.cloud = this.selectClouds.join(",");
      this.updateList++;
    },
    deletedata(val) {
      let url = "cloud/server/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.cloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
